import FileSaver from 'file-saver';
import { actions as jobActions } from '@saucelabs/sl-module-jobs';

import { EDS_SPECIFIC_FILENAMES, RDC_SPECIFIC_FILENAMES } from './constants';
import { FILE_TO_URL_MAPPING_RDC } from '../container/constants';

import { actions, constants } from '.';


export const fetchAndDisplayFile = ({
  availableFiles, auth, jobId, assetName, config,
}) => (dispatch) => {
  dispatch(actions.selectFile(assetName));
  dispatch(actions.showLoader());

  const fileAlreadyDownloaded = availableFiles.get(assetName);


  if (fileAlreadyDownloaded) {
    return dispatch(actions.attachFile({ name: assetName, data: fileAlreadyDownloaded.data }));
  }

  const assetFetchMethod = constants.EDS_SPECIFIC_FILENAMES.includes(assetName) ?
    jobActions.getEdsAsset.bind(jobActions.getEdsAsset) :
    jobActions.getAsset.bind(jobActions.getAsset);

  return dispatch(assetFetchMethod({ id: jobId, auth, assetName, config }, { skipErrorPage: true }))
    .then(({ data }) => dispatch(actions.attachFile({ name: assetName, data })))
    .catch(() => null);
};

export const getBlobFile = ({ assetName, auth, job }) => (dispatch) => {
  let axiosOptions;
  let assetFetchMethod;

  if (job.isRdc()) {
    const fileUrlKey = FILE_TO_URL_MAPPING_RDC[assetName].urlKey;
    const url = job.get(fileUrlKey);
    axiosOptions = { url };
    assetFetchMethod = jobActions.getRdcAsset;
  } else {
    axiosOptions = {
      id: job.get('id'),
      assetName,
      auth,
      params: {
        responseType: 'blob',
      },
      config: {
        transformResponse: (raw) => raw,
      },
    };

    assetFetchMethod = constants.EDS_SPECIFIC_FILENAMES.includes(assetName) ?
      jobActions.getEdsAsset.bind(jobActions.getEdsAsset) :
      jobActions.getAsset.bind(jobActions.getAsset);
  }

  return dispatch(assetFetchMethod(axiosOptions, { skipErrorPage: true }))
    .then((response) => {
      const fileData = response?.data &&
      (EDS_SPECIFIC_FILENAMES.includes(assetName) || RDC_SPECIFIC_FILENAMES.includes(assetName)) ?
        [JSON.stringify(response.data, null, 4)] : [response.data];
      FileSaver.saveAs(new Blob(fileData), assetName);
    });
};
